import { Action } from 'redux';

import { SpaceInfoTypeContentCounts } from '../../state/ContentCountsState';
import { SpaceInfo, SpaceType } from '../../state/SpaceInfo';
import { ContentCountsRequest, ContentCountsRequestSucceeded, ContentCountsUpToDate, UpdateSpaceInfoCount } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

// ContentCountsRequestAction

export interface ContentCountsRequestAction extends Action {}

export function contentCountsRequest(): ContentCountsRequestAction {
  return {
    type: ContentCountsRequest
  };
}

export const isContentCountsRequestAction = isActionFactory<ContentCountsRequestAction>(ContentCountsRequest);

// ContentCountsRequestSucceededAction

export interface ContentCountsRequestSucceededAction extends Action {
  spaceType: SpaceType;
  counts: SpaceInfoTypeContentCounts;
}

export function contentCountsRequestSucceeded(spaceType: SpaceType, counts: SpaceInfoTypeContentCounts): ContentCountsRequestSucceededAction {
  return {
    type: ContentCountsRequestSucceeded,
    spaceType,
    counts
  };
}

export const isContentCountsRequestSucceededAction = isActionFactory<ContentCountsRequestSucceededAction>(ContentCountsRequestSucceeded);

// UpdateSpaceInfoCountAction

export interface UpdateSpaceInfoCountAction extends Action {
  spaceInfo: SpaceInfo;
  count: number;
}

export function updateSpaceInfoCountAction(spaceInfo: SpaceInfo, count: number): UpdateSpaceInfoCountAction {
  return {
    type: UpdateSpaceInfoCount,
    spaceInfo,
    count
  };
}

export const isUpdateSpaceInfoCountAction = isActionFactory<UpdateSpaceInfoCountAction>(UpdateSpaceInfoCount);

// ContentCountsUpToDate

export interface ContentCountsUpToDateAction extends Action {}

export function contentCountsUpToDate(): ContentCountsUpToDateAction {
  return {
    type: ContentCountsUpToDate
  };
}

export const isContentCountsUpToDateAction = isActionFactory<ContentCountsUpToDateAction>(ContentCountsUpToDate);
